import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Button } from '@mui/material';
import { useEffect } from "react";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: 300, md: 500 },
  bgcolor: 'background.paper',
  border: 'none',
  borderRadius: '2em',
  boxShadow: 24,
  p: { xs: 1, md: 4 }, 
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
};

export default function SpecialInstructionModal(props) {

  const [navBarWidth, setNavBarWidth] = React.useState(0);

  useEffect(() => {
    const drawerElement = document.getElementById("main-drawer");

    if (drawerElement) {
      const width = drawerElement.offsetWidth;
      setNavBarWidth( width/2)
    }
  }, []);

  function localOnClick() {
    props.onClick && props.onClick();
    props.handleClose();
  }

  return (
    <div>
      <Modal open={props.open} >
        <Box sx={{...style, marginLeft: `${navBarWidth}px`}}>
          <InfoOutlinedIcon sx={{ color: 'var(--orange)', fontSize: '32px', width: '100%' }} />
          <Typography id="modal-modal-description" sx={{ mt: 2, fontWeight: '700', color: 'var(--orange)' }} align="center" >
            This Job has special instructions that are as follows:
          </Typography>
          <Typography sx={{ mt: 2 }} align="center">
            {props.text}
          </Typography>
          <Typography sx={{ mt: 2, fontWeight: '700', color: 'var(--orange)' }} align="center">
            Click confirm to acknowledge and continue with the Job
          </Typography>

          <div className='basic-modal-button'>
            <Button variant='contained' style={{ width: '100px' }} onClick={localOnClick}>Confirm</Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}